import Video from 'twilio-video';
import { Room } from 'livekit-client';
import { StreamingProvider } from 'globals/enums';
import { livekitWSUrl } from 'common/components/constant';

// Get the max subscription bitrate from environment variable or use default value (8Mbps)
const getMaxSubscriptionBitrate = (): number => {
  const envBitrate = process.env.REACT_APP_TWILIO_SUBSCRIBE_BITRATE;
  return envBitrate ? parseInt(envBitrate, 10) : 8000000;
};

const getRoom = async (stremObject: { token: string; video_provider: string }) => {
  if (stremObject.video_provider === StreamingProvider.Twilio) {
    return await Video.connect(stremObject.token, {
      audio: false,
      video: false,
      bandwidthProfile: {
        video: {
          trackSwitchOffMode: 'disabled',
          // Use environment variable for maxSubscriptionBitrate with default 8000000
          maxSubscriptionBitrate: getMaxSubscriptionBitrate(),
          renderDimensions: {
            low: { width: 320, height: 240 },
            standard: { width: 640, height: 360 },
            high: { width: 1280, height: 720 }
          }
        }
      }
    });
  }
  const room = new Room();
  await room.connect(livekitWSUrl, stremObject.token);
  return room;
};

export default getRoom;
